"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeUtils = void 0;
class TimeUtils {
    static INSTANCE;
    provider;
    constructor(provider) {
        this.provider = provider;
    }
    static getSingleton() {
        if (TimeUtils.INSTANCE === undefined) {
            TimeUtils.INSTANCE = new TimeUtils(new TimeProvider());
        }
        return TimeUtils.INSTANCE;
    }
    // TODO get time from an external service to avoid using local machine timestamp
    static now() {
        return TimeUtils.getSingleton().provider.getCurrentClientTimeSeconds();
    }
    static minute() {
        return BigInt(60);
    }
    static hour() {
        return TimeUtils.minute() * BigInt(60);
    }
    static day() {
        return TimeUtils.hour() * BigInt(24);
    }
    static week() {
        return TimeUtils.day() * BigInt(7);
    }
    static year() {
        return TimeUtils.day() * BigInt(365);
    }
    static async sleep(milliseconds) {
        await new Promise((resolve) => setTimeout(resolve, milliseconds));
    }
}
exports.TimeUtils = TimeUtils;
class TimeProvider {
    getCurrentClientTimeSeconds() {
        return BigInt(Math.round(new Date().getTime() / 1000));
    }
}
